import { Avatar, Typography } from "@braintrust/braintrust-ui-components";
import type { User } from "@js/types/auth";

import style from "./style.module.scss";

type UserTestimonialSlideProps = {
  comment: string;
  user: Pick<
    User,
    | "first_name"
    | "public_name"
    | "avatar"
    | "has_avatar_set"
    | "avatar_thumbnail"
    | "gravatar"
    | "title"
  >;
};

export const UserTestimonialSlide = ({
  comment,
  user,
}: UserTestimonialSlideProps) => {
  return (
    <div className={style.commentSlide}>
      <Typography
        component="span"
        variant="title"
        size="small"
        fontWeight={400}
      >
        {comment}
      </Typography>
      <div className={style.commentSlideUser}>
        <Avatar
          sx={{ width: 46, height: 46 }}
          alt={user.public_name}
          src={user}
        />
        <div className={style.commentSlideName}>
          <Typography component="span" variant="label" size="large">
            {user.public_name}
          </Typography>
          <Typography component="span" variant="paragraph" size="medium">
            {user.title}
          </Typography>
        </div>
      </div>
    </div>
  );
};
